module.exports = __webpack_public_path__ + "img/user-mutuali.59fce06a.svg";